import { render } from "./SelectSector.vue?vue&type=template&id=7ad41d4d&scoped=true"
const script = {}

import "./SelectSector.vue?vue&type=style&index=0&id=7ad41d4d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ad41d4d"

export default script